import Vue from 'vue';
import VueRouter from 'vue-router';
// eslint-disable-next-line import/extensions
import store from '../store/index.js';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/chart',
  },
  {
    path: '/vision',
    name: 'vision',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.

    component() {
      return import(/* webpackChunkName: "about" */ '@/views/VisionTrain.vue');
    },
    meta: { requiresAuth: true },
  },
  {
    path: '/chart',
    name: 'chart',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component() {
      return import(/* webpackChunkName: "about" */ '@/views/Chart.vue');
    },
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component() {
      return import(/* webpackChunkName: "about" */ '@/views/LoginPage.vue');
    },
    meta: { requiresAuth: false },
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  console.log('to=', to.fullPath, '| from=', from.fullPath, to, from);
  if (
    to.matched.some((record) => {
      console.log(record.name, record.meta.requiresAuth);
      return record.meta.requiresAuth;
    })
  ) {
    // 如果沒有 token
    console.log('token?', store.state.token);
    if (localStorage.getItem('token') && Math.floor(Date.now() / 1000) < parseInt(localStorage.getItem('tokenExperies'), 10)) {
      next(); // 往下繼續執行
    } else if (to.query.accessToken) {
      // chaeck query
      next({ path: '/login', query: { accessToken: to.query.accessToken } });
    } else {
      // 轉跳到 login page
      next({ path: '/login' });
    }
  } else {
    next(); // 往下繼續執行
  }
});

export default router;
